/**
 * CSS das folhas A4 da Lista de Compras — fonte ÚNICA usada no preview da tela,
 * no "Baixar PDF" (html2canvas) e na janela de "Imprimir". Escopado em
 * `#rf-print-papers` (não vaza pro resto do app). Identidade NEUTRA do ERP: o
 * acento vem do token `--accent` resolvido (passado como literal), o resto é
 * cinza neutro. Sem vermelho de marca, sem dependência de CSS var na janela.
 */

export function acentoDoApp() {
  try {
    const v = getComputedStyle(document.documentElement)
      .getPropertyValue("--accent")
      .trim();
    return v || "#2563eb";
  } catch {
    return "#2563eb";
  }
}

export function documentoCss(accent = "#2563eb") {
  const S = "#rf-print-papers";
  return `
  ${S} .rf-paper {
    width: 210mm; min-height: 297mm; max-width: 100%; margin: 0 auto 16px;
    background: #fff; color: #111827; padding: 14mm 14mm;
    box-shadow: 0 6px 24px rgba(0,0,0,.18);
    font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 10pt;
  }
  ${S} .phead { display: flex; align-items: flex-end; justify-content: space-between;
    border-bottom: 2px solid #111827; padding-bottom: 6px; margin-bottom: 8px; }
  ${S} .phead-doc { font-size: 13pt; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
  ${S} .phead-date { font-size: 8.5pt; color: #6b7280; font-weight: 600; }
  ${S} .meta { display: flex; flex-wrap: wrap; gap: 0 18px; font-size: 9pt; color: #4b5563;
    padding: 6px 0 8px; border-bottom: 1px solid #e5e7eb; margin-bottom: 12px; }
  ${S} .meta b { color: #111827; }
  ${S} .banner { display: flex; align-items: baseline; gap: 12px; padding: 7px 12px;
    background: #111827; color: #fff; border-left: 4px solid ${accent}; margin-bottom: 10px;
    -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  ${S} .banner-id { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 8.5pt; opacity: .65; }
  ${S} .banner-nome { font-size: 12pt; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; }
  ${S} .banner-folha { margin-left: auto; font-size: 8pt; opacity: .75; text-transform: uppercase; }
  ${S} .resumo-intro { text-align: center; font-size: 9pt; color: #4b5563; margin: 8px 0 12px;
    padding-bottom: 8px; border-bottom: 1px solid #e5e7eb; font-weight: 500; }
  ${S} .modulo { display: flex; align-items: baseline; gap: 10px; margin-top: 12px;
    padding: 5px 0 6px; border-bottom: 1.5px solid #111827; }
  ${S} .mod-mid { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 9.5pt; font-weight: 700;
    color: ${accent}; background: ${accent}1a; padding: 1px 6px; border-radius: 2px;
    -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  ${S} .mod-nome { font-size: 11pt; font-weight: 700; }
  ${S} .mod-count { margin-left: auto; font-size: 8pt; color: #6b7280; }
  ${S} table.itens { width: 100%; border-collapse: collapse; margin-bottom: 4px; }
  ${S} table.itens th { text-align: left; font-size: 7.5pt; font-weight: 600; text-transform: uppercase;
    letter-spacing: .08em; color: #9ca3af; padding: 6px 8px 4px; border-bottom: 1px solid #d1d5db; }
  ${S} table.itens td { padding: 7px 8px; vertical-align: top; border-bottom: 1px solid #eef0f2; font-size: 10pt; }
  ${S} table.itens tbody tr:nth-child(even) td { background: #f7f8fa;
    -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  ${S} th.c-num, ${S} td.c-num { width: 36px; text-align: center; }
  ${S} th.c-qt, ${S} td.c-qt { width: 50px; text-align: center; }
  ${S} th.c-dim, ${S} td.c-dim { width: 110px; text-align: center; font-size: 9pt; color: #4b5563; }
  ${S} td.c-qt { font-size: 11pt; font-weight: 700; }
  ${S} td.c-num { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 8.5pt; color: #9ca3af; }
  ${S} .i-nome { font-weight: 500; }
  ${S} .i-meta { display: block; font-size: 8pt; color: #6b7280; margin-top: 2px; }
  ${S} .vazio { text-align: center; color: #9ca3af; font-style: italic; padding: 28px 0; }
  ${S} .pfoot { margin-top: 20px; padding-top: 10px; border-top: 1px solid #e5e7eb; display: flex;
    justify-content: space-between; font-size: 7.5pt; color: #9ca3af; }
  `;
}

/** CSS adicional só para a JANELA de impressão (limpa fundo + quebra de página). */
export function documentoCssJanela() {
  return `
  @page { size: A4; margin: 0; }
  body { margin: 0; background: #fff; }
  #rf-print-papers .rf-paper { box-shadow: none !important; margin: 0 auto !important;
    page-break-after: always; }
  #rf-print-papers .rf-paper:last-child { page-break-after: auto; }
  @media print {
    #rf-print-papers table.itens thead { display: table-header-group; }
    #rf-print-papers table.itens tbody tr { page-break-inside: avoid; }
    #rf-print-papers .modulo { page-break-after: avoid; }
  }
  `;
}
